import { action } from '@ember/object';
import Service from '@ember/service';
import { tracked } from 'tracked-built-ins';

type Notification = {
  header: string;
  message: string;
  type: 'success' | 'warning' | 'error' | 'info';
  timeout: number;
};

export default class NotificationService extends Service {
  notifications: Notification[] = tracked([]);
  // constructor() {
  //   super(...arguments);
  //   this.success('asd');
  //   this.error('asd');
  //   this.warning('asd');
  //   this.info('asd');
  // }

  success(message: string, header: string = 'Erfolg') {
    this.notifications.push({
      type: 'success',
      header,
      message,
      timeout: 5000,
    });
  }
  warning(message: string, header: string = 'Warnung') {
    this.notifications.push({
      type: 'warning',
      header,
      message,
      timeout: 5000,
    });
  }
  error(message: string, header: string = 'Fehler') {
    this.notifications.push({ type: 'error', header, message, timeout: 5000 });
  }
  info(message: string, header: string = 'Info') {
    this.notifications.push({ type: 'info', header, message, timeout: 5000 });
  }
  @action
  removeNotification(notification: Notification) {
    this.notifications.splice(this.notifications.indexOf(notification), 1);
  }
}

// Don't remove this declaration: this is what enables TypeScript to resolve
// this service using `Owner.lookup('service:notification')`, as well
// as to check when you pass the service name as an argument to the decorator,
// like `@service('notification') declare altName: NotificationService;`.
declare module '@ember/service' {
  interface Registry {
    notification: NotificationService;
  }
}
